<template>
  <div>
    <div class="w-100" style="">
      <div class="container">
        <!-- E Voucher issue queue list -->
        <div class="row">
          <div
            class="col-6 col-md-3 font-size-medium"
            v-for="(voucherItem, index) in voucherItems"
            :key="voucherItem + index"
          >
            <div
              :class="['bg-white p-2 cursor-pointer mt-4 card shadow', index == (voucherItems.length - 1) ? 'mb-4' : '']"
              style="border: 1px solid #e5e5e5; border-radius: 10px;"
              @click="nextPage(voucherItem)"
            >
              <div class="center-item" style="height: 100px;">
                <div class="button-title w-75 text-left second-color">
                  <span class="text-uppercase" style="display: block;">
                    {{ $t(voucherItem.title) }}
                  </span>
                  <span>
                    {{ voucherItem.value }}
                  </span>
                </div>
                <div class="button-icon w-25 text-right">
                  <img :src="voucherItem.image" style="width: 70%;" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <my-voucher-list
      :isShow="false"
    ></my-voucher-list>
    <!-- <div class="container group-chart" style="display:flex;">
        <div class="chart line">
          <div class="chart-header">
            <div class="header-left">
              <div class="title">
                {{ $t('dashboard.chart.chartLine.overview') }}
              </div>
              <div class="content">
                {{ $t('dashboard.chart.chartLine.voucherUsed') }}
              </div>
            </div>
            <div class="header-right">
              <div class="button">
                <button type="button" class="btn-show" v-bind:class="{ active: isActiveMonth }"  @click="handleChartLine('month')">{{ $t('dashboard.chart.chartLine.month') }}</button>
              </div>
              <div class="button">
                <button type="button" class="btn-show" v-bind:class="{ active: isActiveWeek }" @click="handleChartLine('week')">{{ $t('dashboard.chart.chartLine.week') }}</button>
              </div>
            </div>
          </div>
          <chartLine/>
        </div>
        <div class="chart bar">
          <div class="chart-header">
            <div class="header-left">
              <div class="title">
                {{ $t('dashboard.chart.chartBar.performance') }}
              </div>
              <div class="content">
                {{ $t('dashboard.chart.chartBar.totalPurchased') }}
              </div>
            </div>
          </div>
          <chartBar
            :data="chartBar.chartBarData"
            :options="chartBar.options"
          />
        </div>
    </div> -->
    <!-- <div class="container">
      <div class="chart doughnut">
        <div class="chart-header">
          <div class="header-left">
            <div class="title">
              {{ $t('dashboard.chart.chartDoughnut.overview') }}
            </div>
            <div class="content">
              {{ $t('dashboard.chart.chartDoughnut.const') }}
            </div>
          </div>
          <div class="header-right">
            <div class="button">
              <input type="text">
            </div>
          </div>
        </div>
        <div class="group-content">
          <chartDoughnut
            @dataChartDoughnut="dataChartDoughnut"
            style="width:286px;height:286px;margin-right: 40px;"
          />
          <div class="text-inside-chart">
            <p>Total Budget</p>
          </div>
          <div class="annotate">
            <table class="table">
              <tbody>
                <tr>
                  <th scope="row"><i class="fas fa-dot-circle" style="color: #2DCE98;"></i></th>
                  <th>{{ $t('dashboard.chart.chartDoughnut.voucherUsed') }}</th>
                  <td></td>
                  <td>{{convertToMoney(chartDoughnutData[0])}} VND</td>
                </tr>
                <tr>
                  <th scope="row"><i class="fas fa-dot-circle" style="color: #11CDEF;"></i></th>
                  <th>{{ $t('dashboard.chart.chartDoughnut.VoucherNotUsed') }}</th>
                  <td></td>
                  <td>{{convertToMoney(chartDoughnutData[1])}} VND</td>
                </tr>
                <tr>
                  <th scope="row"><i class="fas fa-dot-circle" style="color: #FEB969;"></i></th>
                  <th>{{ $t('dashboard.chart.chartDoughnut.voucher') }}</th>
                  <td></td>
                  <td>{{convertToMoney(chartDoughnutData[2])}} VND</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->
    <loadingBar :useSlot="true" :isLoading="isLoading"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VoucherTypeEnum from 'Enum/voucherType'
import functionUtils from "Utils/functionUtils";
import MyVoucherList from "Views/EVoucher/MyVoucherList";
// import chartLine from '@/components/chartLine.vue'
// import chartBar from '@/components/chartBar.vue'
// import chartDoughnut from '@/components/chartDoughnut.vue'

export default {
  components: {
    'my-voucher-list': MyVoucherList},
  data: () => ({
    voucherItems: [
      {
        title: "evoucher.voucherNotUseYet",
        value: '0',
        type: VoucherTypeEnum.VOUCHER_NOT_USE_YET,
        image: require("../../assets/voucher_icon_5.svg"),
      },
      {
        title: "evoucher.voucherWaitingConfirm",
        value: '0',
        type: VoucherTypeEnum.VOUCHER_WAITING_USE,
        image: require("../../assets/voucher_icon_3.svg"),
      },
      {
        title: "evoucher.voucherUsed",
        value: '0',
        type: VoucherTypeEnum.VOUCHER_USED,
        image: require("../../assets/voucher_icon_1.svg"),
      },
      {
        title: "evoucher.voucherTransferred",
        value: '0',
        type: VoucherTypeEnum.VOUCHER_TRANSFERRED,
        image: require("../../assets/voucher_icon_2.svg"),
      }
    ],
    labelsChartDoughnut: ['dashboard.chart.chartDoughnut.voucherUsed', 'dashboard.chart.chartDoughnut.VoucherNotUsed', 'dashboard.chart.chartDoughnut.voucher'],
    chartDoughnutData: [],
    isLoading: false,
    isActive: true,

    // ChartBar data
    chartBar: {
      chartBarData: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [{
          backgroundColor: ['#3e95cd', '#8e5ea2', '#3cba9f', '#e8c3b9', '#c45850', '#3e95cd', '#8e5ea2'],
          data: [63, 52, 73, 78, 80, 79, 82]
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: false
      }
    },
   isActiveMonth: true,
   isActiveWeek: false,
   chartLineData: [],
   typeSelected: VoucherTypeEnum.VOUCHER_NOT_USE_YET
  }),
  computed: {
    ...mapGetters(['VOUCHER_STATUS_STATISTICS_DATA'])
  },
  watch: {
    VOUCHER_STATUS_STATISTICS_DATA () {
      let res = this.VOUCHER_STATUS_STATISTICS_DATA
      for (let i = 0, size = this.voucherItems.length; i < size; i++) {
        // Total voucher
        if (this.voucherItems[i].type == VoucherTypeEnum.TOTAL_VOUCHER) {
          this.voucherItems[i].value = res.total_voucher
          // Total money voucher
        } else if (this.voucherItems[i].type == VoucherTypeEnum.TOTAL_MONEY_VOUCHER) {
          this.voucherItems[i].value = this.convertToMoney(res.total_money_voucher) + ' VND'
          // Total voucher waiting confirmation
        } else if (this.voucherItems[i].type == VoucherTypeEnum.VOUCHER_WAITING_USE) {
          this.voucherItems[i].value = res.voucher_waiting_for_confirmation
          // Total voucher used
        } else if (this.voucherItems[i].type == VoucherTypeEnum.VOUCHER_USED) {
          this.voucherItems[i].value = res.voucher_used
          // Total money voucher used
        } else if (this.voucherItems[i].type == VoucherTypeEnum.TOTAL_MONEY_VOUCHER_USED) {
          this.voucherItems[i].value = this.convertToMoney(res.total_money_voucher_used) + ' VND'
          // Total voucher expired
        } else if (this.voucherItems[i].type == VoucherTypeEnum.VOUCHER_EXPIRED) {
          this.voucherItems[i].value = res.total_vouchers_expired
        } else if (this.voucherItems[i].type == VoucherTypeEnum.VOUCHER_NOT_USE_YET) {
          this.voucherItems[i].value = res.voucher_not_use_yet
        }
      }
    },
  },
  created () {
    this.isLoading = true
    this.VOUCHER_STATUS_STATISTICS().then(
      function () {
        this.isLoading = false
      }.bind(this)
    ).catch(
      function () {
        this.isLoading = false
      }.bind(this)
    )
  },
  methods: {
    /**
     * Convert to money
     */
    convertToMoney: function(value) {
      return functionUtils.convertFormatNumberToMoney(value);
    },
    nextPage(voucherItem) {
      if (voucherItem.type != VoucherTypeEnum.TOTAL_MONEY_VOUCHER && voucherItem.type != VoucherTypeEnum.TOTAL_MONEY_VOUCHER_NOT_USE_YET && voucherItem.type != VoucherTypeEnum.TOTAL_MONEY_VOUCHER_IS_USING && voucherItem.type != VoucherTypeEnum.TOTAL_MONEY_VOUCHER_USED) {
        this.typeSelected = voucherItem.type
      }
    },
    dataChartDoughnut(e) {
      this.chartDoughnutData = e
    },
    ...mapActions(['VOUCHER_STATUS_STATISTICS'])
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
:deep(.btn-outline-success:hover) {
  color: #fff !important;
}
.center-item {
  display: flex;
  align-items: center;
}

// Css for chart

  .vld-parent {
    display: none !important;
  }


  .chart {
    font-family: Gotham;
    background-color: #F7FAFC;
    box-shadow: 0 0px 17px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 30px;
    margin: 30px 30px 0 0;

    &.line {
      width: 70%;
    }

    &.bar {
      width: 30%;
    }

    &.doughnut {
      width: 70%;
      float: right;

      .group-content {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 80px;

        .annotate {
          width: calc(100% - 286px);
        }

        .text-inside-chart {
          p {
            position:absolute;
            transform:translate(-285%,10px);
            font-size:15px;
            text-align:center;
            opacity:0.8;
          }
        }
      }
    }

    .chart-header {
      display: flex;
      justify-content: space-between;
      margin: 30px 0 55px 0;

      .header-left {
        .title {
          font-size: 11px;
        }

        .content {
          font-size: 18px;
        }
      }

      .header-right {
        display: flex;
        .btn-show {
          width: 85px;
          height: 45px;
          border-radius: 5px;
          background-color: #fff;
          color: #333;
          border: 1px solid #333;
          margin-left: 15px;

          &.active {
            border: none;
            background-color: $primary;
            color: #fff;
          }

          &:focus {
            outline: none;
          }
        }

        input {
          height: 50px;
          border-radius: 5px;
          border: 2px solid #7764E4;
          color: #7764E4;

          &:focus{
            outline: none;
            border: 2px solid #7764E4;
          }

          ::-webkit-input-placeholder { /* Edge */
            font-size: 14px;
            color: #7764E4;
          }

          :-ms-input-placeholder { /* Internet Explorer */
            font-size: 14px;
            color: #7764E4;
          }

          ::placeholder {
            font-size: 14px;
            color: #7764E4;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 769px) {
    .container.group-chart {
      flex-wrap: wrap;

      .chart {
        margin: 30px 0;
        &.line {
          width: 100%;
        }

        &.bar {
          width: 100%;
        }
      }
    }
    .container {
      .chart {
        margin: 30px 0;
        &.doughnut {
          width: 100%;
        }
      }
    }
  }

  @media only screen and (max-width: 1200px) {
    .container {
      .chart {
        &.doughnut {
          .group-content {
            flex-wrap: wrap;

            p {
              transform: translate(-15%, -280%) !important;
            }

            .annotate {
              width: 100%;
              margin-top: 40px;
            }

            .text-inside-chart {
              p {
                transform:translate(-285%,10px) !important;
              }
            }
          }
        }
      }
    }
  }
</style>
